module.exports = __webpack_public_path__ + "img/logo.147b4fcb.svg";